var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.041748 9.00033C0.041748 4.07181 4.07157 0.0419922 9.00008 0.0419922C13.9286 0.0419922 17.9584 4.07181 17.9584 9.00033C17.9584 13.9288 13.9286 17.9587 9.00008 17.9587C4.07157 17.9587 0.041748 13.9288 0.041748 9.00033ZM9.00008 1.29199C4.76193 1.29199 1.29175 4.76217 1.29175 9.00033C1.29175 13.2385 4.76193 16.7087 9.00008 16.7087C13.2382 16.7087 16.7084 13.2385 16.7084 9.00033C16.7084 4.76217 13.2382 1.29199 9.00008 1.29199Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.04175 9.00033C5.04175 8.65515 5.32157 8.37533 5.66675 8.37533H12.3334C12.6786 8.37533 12.9584 8.65515 12.9584 9.00033C12.9584 9.34551 12.6786 9.62533 12.3334 9.62533H5.66675C5.32157 9.62533 5.04175 9.34551 5.04175 9.00033Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00008 5.04199C9.34526 5.04199 9.62508 5.32181 9.62508 5.66699V12.3337C9.62508 12.6788 9.34526 12.9587 9.00008 12.9587C8.6549 12.9587 8.37508 12.6788 8.37508 12.3337V5.66699C8.37508 5.32181 8.6549 5.04199 9.00008 5.04199Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.fb7f925c4bfcad79f6bb78a0244bda75.svg";
export { ForwardRef as ReactComponent };